import { render } from "./publish.vue?vue&type=template&id=177ce670&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"

import "./publish.vue?vue&type=style&index=0&id=177ce670&scoped=scoped&lang=less"
import "./publish.vue?vue&type=style&index=1&id=177ce670&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177ce670"]])

export default __exports__